import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService } from '../../../core/services/config/server/config-server.service';
import { IUsuarioInativarRequest } from '../interfaces/usuario-inativar-request.interface';
import { IUsuarioReativarRequest } from '../interfaces/usuario-reativar-request.interface';

@Injectable({
  providedIn: 'root',
})
export class UsuarioApi {
  private apiUrl = `${this.configServerService.getPathApi()}/usuario`;

  constructor(
    private http: HttpClient,
    private configServerService: ConfigServerService
  ) {}

  /** Inativa o usuário informado */
  inativar(id: number, payload: IUsuarioInativarRequest): Observable<string> {
    return this.http.put<string>(`${this.apiUrl}/${id}/inativar`, payload);
  }

  /** Reativa o usuário informado */
  reativar(id: number, payload: IUsuarioReativarRequest): Observable<string> {
    return this.http.put<string>(`${this.apiUrl}/${id}/reativar`, payload);
  }
}
